export const CATEGORY = "home";
export const ACTION = "prime_welcome_popup";
export const LABEL = {
  RENDER:
    "prime_welcome_popup_prime_welcome_popup_onload_msg:Y:hotel:hotel benefits",
  OPEN: "prime_welcome_popup_onload_msg:hotel:hotel benefits",
  CLOSE: "prime_welcome_popup_close_msg:hotel:hotel benefits",
  BENEFIT: "prime_welcome_popup_click_msg:hotel:hotel benefits",
};
export const DATAMESH_ONLOAD_EVENT = "welcome-back-prime_onload";
export const DATAMESH_ONCLICK_EVENT = "welcome-back-prime_click:close";
export const DATAMESH_BACKDROP_ONCLICK_EVENT =
  "welcome-back-prime_click:backdrop";
